import { RISK_NAME } from 'containers/CourtManagerLegalProceedings/Provision/constants';

export const RISK_DATA = {
  VICTIMS: 'victims',
  VEHICLES: 'vehicles',
  ADDITIONAL_GARENTIES: 'additionalGuarantees',
};
export const FEES = {
  FUNERAL_FEES: 'Frais obsèques',
  MEDICAL_FEES: 'Frais médicaux',
};
export const ABANDON = {
  REFUSED: 'REFUSED',
  PARTIAL: 'PARTIAL',
  TOTAL: 'TOTAL',
};
export const PROVISION_ITEM = {
  CONTRIBUTORS: 'contributors',
  VICTIMS: 'victims',
};
export const SHEETS = {
  SUMMARY_SHEET: 'SUMMARY_SHEET',
  CNRA_SHEET: 'CNRA_SHEET',
  CDRA_SHEET: 'CDRA_SHEET',
};
export const JUDICIARY_TYPE = {
  APPEAL: 'APPEAL',
  FIRST_INSTANCE: 'FIRST_INSTANCE',
};
export const BORDER_COLOR = '#000';
export const BORDER_STYLE = 'solid';
export const JUDGEMENT_DATE = 'jom.judgementDate';
export const CALCULATION_START_DATE = 'jom.calculationStartDate';
export const JUDGEMENT_ID_JOM = 'jom.judgementId';
export const COURT_NUMBER = 'jom.judgementNumber';
export const OPPOSING_LAWYER = 'judiciaryProcess.opposingLawyer';
export const IDD = 'jom.idd';
export const RISKS = [
  {
    item: RISK_DATA.VICTIMS,
    riskName: RISK_NAME.CORPOREAL,
  },
  {
    item: RISK_DATA.VEHICLES,
    riskName: RISK_NAME.MATERIEL,
  },
  {
    item: RISK_DATA.ADDITIONAL_GARENTIES,
    riskName: RISK_NAME.GARANTIES_ANNEXES,
  },
];
export const PARTIAL_SUBSTITUTE = 'Partiel';
export const REMAINDER_SUBSTITUTE = 'Reliquat';
export const TOTAL_SUBSTITUTE = 'Total';
export const TRANSACTION = 'Transaction';
export const DOCUMENT_NATURE = {
  PARTIAL: { title: 'Exécution provisoire', substitute: PARTIAL_SUBSTITUTE },
  REMAINDER: { title: 'Reliquat jugement', substitute: REMAINDER_SUBSTITUTE },
  TOTAL_JUDGEMENT: {
    title: 'Jugement',
    substitute: TOTAL_SUBSTITUTE,
  },
  TOTAL_APPEAL: {
    title: 'Arrét',
    substitute: TOTAL_SUBSTITUTE,
  },
};
export const NEXT_OF_KIN = 'Ayany droit';
export const JUDICIARY_PAYMENT_NATURE = 'Judiciaire';
export const PAYMENT_METHODS = {
  SEIZURE_APPEAL: 'Saisie Arrêt',
  CHECK_LETTER: 'Lettre-Chèque',
  TRANSFER: 'Virement',
};
export const FORMAT_DATE = 'DD/MM/YYYY';
export const LINK_BENEFICIARY_RECIPIENT = {
  CDRA: 'C.D.R.A',
  BNEJ: 'B.N.E.J',
  CNRA: 'C.N.R.A',
  INSURED: 'Lui même',
  AGENT: 'Point de vente',
};
export const RECIPIENT = {
  BNEJ: 'BNEJ',
  CDRA: 'CDRA',
  OTHERS: 'Autre',
  CNRA: 'CNRA',
};
export const PAYMENT_CHANNEL = {
  BNEJ: 'Exécution forcée',
  CDRA: 'CDRA',
  CNRA: {
    FRIENDLY: 'CNRA - Règlement amiable',
    FORCED: 'CNRA - Exécution forcée',
  },
};
export const REJECTION_REGULATION_TYPE = [
  {
    title: 'Rejeter - à refaire',
    type: 'REJECT_TO_REDO',
  },
  {
    title: 'Rejeter - à annuler',
    type: 'REJECT_TO_CANCEL',
  },
];
export const REGULATION_STATUS = 'Reçu';
export const REGULATION_PAYMENT_TYPE = 'Lettre-Chèque';
export const REGULATION_PAYMENT_STATUS_TO_PAY = 'A payer';
export const REGULATION_PAYMENT_STATUS_PAY = 'Payé';
export const REGULATION_PAYMENT_STATUS_ON_HOLD = 'En attente';
export const REGULATION_LEVEL_REQUIREMENT = 'Facultatif';
export const CLIENT = 'CLIENT';
export const CASABLANCA = 'C';
export const MOHAMMADIA = 'M';
export const TYPES = {
  VICTIM: 'victim',
  BENEFICIARY: 'nextOfKin',
};
export const NONE = 'Aucune';
export const MOROCCO_COUNTRY = 'Maroc';
export const RABAT_CITY = 'RABAT';
export const RISK = {
  MATERIAL: 'rcMaterial',
  CORPOREAL: 'rcCorpo',
};
export const BNEJ_MOHAMADIA = 'SECRETAIRE GREFFIER EN CHEF TPI MOHAMMADIA';
export const CDRA_BAR = 'BARREAU';
export const CDRA_BOARD = 'CDRA BARREAU';
export const STOP_ENTRY = 'Saisie Arrêt';
export const VICTIM_TYPES = {
  ADULT_VICTIM: 'VA',
  MINOR_VICTIM: 'VM',
  ADULT_NEXT_OF_KIN: 'AA',
  MINOR_NEXT_OF_KIN: 'AM',
};
export const BNEJ_CITIES = {
  Casablanca: 'BNEJ',
  Mohammedia: 'Sec greffier en chef TPI Mohammedia',
  Benslimane: 'Sec Greffier en chef TPI Benslimane',
} as any;
export const PAID_STATUS = 'Payé';
export const TO_BE_PAID_STATUS = 'A payer';
export const REGULATION_STATUSES_CODES = {
  TO_BE_PAID: {
    key: '112',
    labelFR: 'A payer',
  },
  CANCELED: {
    key: '130',
    labelFR: 'Annulé',
  },
  PAID: {
    key: '111',
    labelFR: 'Payé',
  },
  PENDING: {
    key: '132',
    labelFR: 'En attente',
  },
  REJECTED: {
    key: '138',
    labelFR: 'Rejeté',
  },
};

export const getStatusByKey = (key: string) => {
  return Object.keys(REGULATION_STATUSES_CODES).find(
    status =>
      REGULATION_STATUSES_CODES[
        status as keyof typeof REGULATION_STATUSES_CODES
      ].key === key,
  );
};

export const CHECK_PRINT_MAX_USERNAME_LENGTH = 6;

export const DOCUMENT_MAPPER = {
  CNRA_SHEET: 'Lettre CNRA',
  CDRA_SHEET: 'Lettre CDRA',
  SUMMARY_SHEET: 'Fiche Synthèse',
};

export const PAYMENT_CHANNEL_MAPPER = {
  BNEJ: '5',
};

export const REGULATION_JUDGEMENT_PROCEDURE_TYPE = [
  { key: 'APPEAL', value: 'Appel' },
  { key: 'FIRST_INSTANCE', value: 'Première instance' },
];
export const PROCESS_NATURE_MAPPER = {
  COMMERCIALE: 1,
  CIVILE: 2,
  CORRECTIONNELLE: 3,
};
export const OTHER_REJECTION_REASON = 'Autre';
export const RECAP_REJECTION_REGULATION_TYPE = [
  {
    title: 'à refaire',
    type: 'REJECT_TO_REDO',
  },
  {
    title: 'à annuler',
    type: 'REJECT_TO_CANCEL',
  },
];
